import { snackbar } from "@bcmi-labs/art-ui"
import { createFileRoute, redirect } from "@tanstack/react-router"
import * as v from "valibot"

import { $rqSmartFoldersApiClient } from "@/api/groups"
import { getXOrganizationHeaders } from "@/api/utils"
import { ensureValidQueryData } from "@/api/utils/ensureValidQueryData"
import { routeGuard } from "@/lib/routing/beforeLoad"

const searchSchema = v.object({
  folderId: v.optional(v.string())
})

export const Route = createFileRoute("/_authlayout/_sidebar/devices/smartfolder/$id/")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { permission: { flag: "folder::read", fallbackRoute: { to: "/devices" } } })
  },
  // Validation lives in the loader: `beforeLoad` reruns on every navigation into
  // this tree, including a sibling `?folderId=` switch that has nothing to do
  // with the folder.
  loader: async ({ context: { spaceStorage }, params, cause }) => {
    const { data: folder, error } = await ensureValidQueryData(
      $rqSmartFoldersApiClient.queryOptions("get", "/groups/v1/smartfolders/{smart_folder_id}", {
        params: {
          header: getXOrganizationHeaders(spaceStorage.getSpace()),
          path: { smart_folder_id: params.id }
        }
      })
    )

    if (error) {
      if (cause === "enter") {
        snackbar({
          description: "Smart folder not found",
          variant: "error"
        })
      }
      throw redirect({ to: "/devices" })
    }

    return { folder }
  },
  head: ctx => ({
    meta: [
      {
        title: `Devices - ${ctx.loaderData?.folder.name || "Smart folder"} | Arduino Cloud`
      }
    ]
  })
})
